<template>
  <div :id="localeClass" :class="{ 'platform__pc': !isTriageDeskPage }">
    <TriageDeskHeader v-if="isTriageDeskPage" />
    <USHeader v-else-if="showUsHeader" />
    <Header v-else />
    <template v-if="$nuxt.isOffline">
      <div class="network-offline-container">
        <Exception tip-text="Loading failed, please check your connection." placeholder-class-name="system-error-img" :show-retry-btn="true" @retry="reload" />
      </div>
    </template>
    <template v-else>
      <template v-if="!isNeedLogin || isLogin">
        <nuxt />
      </template>
      <template v-else>
        <DefaultGuideLogin />
      </template>
    </template>

    <no-ssr>
      <OnlineService v-if="$store.state.locale === 'sg' || $store.state.locale === 'uk'" />
      <QiyuCustomerService v-if="$store.state.locale === 'us'" />
      <!-- 登录及绑定邮箱弹窗 -->
      <LoginDialog :show.sync="showLoginDialog" :success-url="loginSuccessUrl" :trigger-src="loginTriggerSrc" :login-trigger-source="loginTriggerSource" :is-group="isGroup" />
      <BindEmailDialog :show.sync="showBindEmailDialog" :success-url="bindEmailSuccessUrl" :trigger-src="bindEmailTriggerSrc" />
      <CompleteStuInfoDialog ref="completeStuInfoDialog" :trigger-args="completeStuInfoTriggerArgs" />
      <UnpaidDialog ref="unpaidDialog" />
      <AppointmentDiagnosis v-if="showDiagnosis" :show.sync="showDiagnosis" :diagnosis-info="diagnosisInfo" />
    </no-ssr>
  </div>
</template>

<script>
import bus from 'common/bus';
import headMixin from 'mixins/layout/head';
import authPathNames from 'config/authPathNames';
import Header from '@/components/global/FeatureComponents/Header/web';
import OnlineService from 'components/common/OnlineService/index.vue'
import QiyuCustomerService from '@/components/global/FeatureComponents/QiyuCustomerService/web.vue'
import LoginDialog from 'components/login/LoginDialog/index.vue';
import BindEmailDialog from 'components/login/BindEmailDialog/index.vue';
import CompleteStuInfoDialog from 'components/login/CompleteStuInfoDialog/index.vue';
import DefaultGuideLogin from 'components/common/DefaultGuideLogin/index.vue';
import Exception from 'components/common/Exception/index.vue';
import UnpaidDialog from 'components/common/UnpaidDialog/index.vue';
// import AppointmentDiagnosis from 'components/appointmentDiagnosis/index.vue';
import USHeader from '@/components/global/FeatureComponents/USHeader/web';
import TriageDeskHeader from '@/components/global/FeatureComponents/TriageDeskHeader/web';
import { getFaviconLink } from 'common/utils.js';

const AppointmentDiagnosis = () => import('components/appointmentDiagnosis/index.vue');

export default {
  components: {
    Header, OnlineService, QiyuCustomerService, LoginDialog, BindEmailDialog, CompleteStuInfoDialog, DefaultGuideLogin, Exception, UnpaidDialog, AppointmentDiagnosis, USHeader, TriageDeskHeader,
  },
  mixins: [headMixin],
  data() {
    const isNeedLogin = authPathNames[this.$route.name];
    return {
      isNeedLogin,
      // 登录弹窗
      showLoginDialog: false,
      // 绑定邮箱弹窗
      showBindEmailDialog: false,
      loginSuccessUrl: '',
      bindEmailSuccessUrl: '',
      loginTriggerSrc: '',
      loginTriggerSource: '',
      bindEmailTriggerSrc: '',
      completeStuInfoTriggerArgs: null,
      isGroup: false,
      showDiagnosis: false,
      diagnosisInfo: {},
    }
  },
  computed: {
    /**
     * 当前语言环境样式名
     * 可通过此样式名叠加样式实现不同语言样式
     */
    localeClass() {
      return `locale__${this.$store.state.locale}`;
    },
    /**
     * 登录态
     */
    isLogin() {
      return this.$store.state.ucenter.isLogin;
    },
    schoolCode() {
      return this.$store.state.schoolCode;
    },
    showUsHeader() {
      const schoolList = ['415', '8601', '105']
      if (schoolList.includes(this.schoolCode)) {
        return true;
      }
      return false;
    },
    isTriageDeskPage() {
      return this.$route.path.includes('/triage-desk');
    },
  },
  mounted() {
    // 页面刷新强制跳转到页面顶部
    document.documentElement.scrollTop = 0;

    if (!this.isLogin && this.isNeedLogin) {
      if (this.isTriageDeskPage) {
        // 如果是分诊台页面 优先注册页面
        this.loginTriggerSource = 'down'
      }
      this.login()
    }

    // 登录弹窗
    bus.$on('login', (argsObj) => {
      if (argsObj && argsObj.triggerSrc) {
        this.loginTriggerSrc = argsObj.triggerSrc;
      }
      if (argsObj && argsObj.triggerSource) {
        this.loginTriggerSource = argsObj.triggerSource
      }
      if (argsObj && argsObj.successUrl) {
        this.loginSuccessUrl = argsObj.successUrl;
      }
      if (argsObj && argsObj.isGroup) {
        this.isGroup = argsObj.isGroup;
      }
      this.login();
    });

    // 预约诊断弹窗
    bus.$on('toShowDiagnosis', (argsObj) => {
      this.toShowDiagnosis(argsObj);
    });

    this.$nextTick(() => {
      // 完善学员信息弹窗
      bus.$on('complete-stu-info', (argsObj) => {
        if (argsObj) this.completeStuInfoTriggerArgs = argsObj;
        this.completeStuInfo(argsObj);
      });
      // 续报提醒弹窗
      bus.$on('openUnpaidDialog', () => {
        this.openUnpaidDialog();
      });
    })
  },
  destroyed() {
    // 页面销毁的时候取消监听
    bus.$off('login')
    bus.$off('toShowDiagnosis')
    bus.$off('complete-stu-info')
    bus.$off('openUnpaidDialog')
  },
  methods: {
    login() {
      this.showLoginDialog = true;
    },
    toShowDiagnosis(argsObj) {
      console.log('进2')
      this.diagnosisInfo = argsObj || {}
      this.showDiagnosis = true
    },
    bindEmail() {
      this.showBindEmailDialog = true;
    },
    completeStuInfo(argsObj) {
      if (this.$refs.completeStuInfoDialog) this.$refs.completeStuInfoDialog.openDialog(argsObj);
    },
    reload() {
      if (this.$nuxt.isOffline) return;
      window.location.reload();
    },
    openUnpaidDialog() {
      if (this.$refs.unpaidDialog) this.$refs.unpaidDialog.openDialog();
    },
  },
  head() {
    const betterme = this.$store.state.betterme === 'bettermeedu' ? 'bettermeedu' : 'default';
    return {
      ...headMixin.head.call(this),
      htmlAttrs: {
        id: `style__${this.$store.state.betterme}`,
      },
      link: getFaviconLink(betterme),
    }
  },
}
</script>
